import { FC } from 'react';
import { AssistantAttachment } from '@/types/assistant';

interface Props {
  /** Contratos/anexos já enviados nesta conversa (persistidos no backend). */
  contracts: AssistantAttachment[];
  onDelete: (id: string) => void;
  deletingId?: string | null;
}

/**
 * J07 (plano-mãe §11): barra de confidencialidade do assistente jurídico.
 * Avisa que o contrato fica guardado até o usuário apagar, lista os contratos
 * enviados com botão "apagar contrato", e reforça que a análise é apoio (confirme
 * no original). Aparece só pros assistentes confidenciais (ex.: H.Lex).
 */
const ConfidentialityPanel: FC<Props> = ({ contracts, onDelete, deletingId }) => {
  return (
    <div
      data-testid="confidentiality-panel"
      className="border-b border-surface-border bg-amber-500/5 px-4 py-1.5 text-xs flex items-center gap-x-3 gap-y-1 flex-wrap"
    >
      <span className="inline-flex items-center gap-1.5 text-content-tertiary">
        <span className="material-symbols-outlined text-amber-400 text-sm leading-none">lock</span>
        <span>
          <span className="font-medium text-content-secondary">Confidencial.</span> Guardado nesta
          conversa até apagar · análise é <strong>apoio</strong>, confirme no original.
        </span>
      </span>

      {contracts.length > 0 && (
        <ul className="inline-flex items-center gap-1.5 flex-wrap" data-testid="contract-list">
          {contracts.map((c) => (
            <li
              key={c.id}
              data-testid="contract-item"
              className="inline-flex items-center gap-1 max-w-[240px] rounded-full bg-surface-secondary border border-surface-border pl-2 pr-1 py-0.5"
            >
              <span className="material-symbols-outlined text-content-tertiary text-sm leading-none">
                description
              </span>
              <span className="truncate text-content-secondary">{c.filename}</span>
              <button
                type="button"
                data-testid="delete-contract"
                onClick={() => onDelete(c.id)}
                disabled={deletingId === c.id}
                aria-label="Apagar contrato desta conversa"
                title="Apagar contrato desta conversa"
                className="shrink-0 grid place-items-center rounded-full p-0.5 text-content-tertiary hover:text-red-400 hover:bg-red-500/10 disabled:opacity-50 transition"
              >
                <span className="material-symbols-outlined text-sm leading-none">close</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ConfidentialityPanel;
